module.exports = __webpack_public_path__ + "img/design_complete_fd.c97539c0.svg";